import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authPlatformAuthorizeV01Post } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postAuthPlatformAuthorizeV01 = createAsyncThunk(
    'postAuthPlatformAuthorizeV01/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await authPlatformAuthorizeV01Post(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_ADMIN_AUTH_PLATFORM_V01_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postAuthPlatformAuthorizeV01Slice = createSlice({
    name: 'postAuthPlatformAuthorizeV01',
    initialState,
    extraReducers: {
        [postAuthPlatformAuthorizeV01.pending]: (state) => {
            state.loading = true;
        },
        [postAuthPlatformAuthorizeV01.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postAuthPlatformAuthorizeV01.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postAuthPlatformAuthorizeV01Selector = (state) => state.postAuthPlatformAuthorizeV01;
export const postAuthPlatformAuthorizeV01Reducer = postAuthPlatformAuthorizeV01Slice.reducer;
